// extracted by mini-css-extract-plugin
module.exports = {"negative":"Balance_negative__3LAMS","positive":"Balance_positive__1MRhc","avgP":"Balance_avgP__1fc8v","avgN":"Balance_avgN__pPwnW"};